import { ConfigurationSection, IConfigurationSection } from './Section';

export interface IConfiguration {
    sections: ConfigurationSection[];
    date?: string;
}

export class Configuration {
    public sections: ConfigurationSection[];
    public date?: string;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IConfiguration);
    // tslint:disable-next-line: unified-signatures
    constructor(obj: { sections: IConfigurationSection[] });
    constructor(obj?: any) {
        this.date = obj && obj.date != null && obj.date.length > 0 ? obj.date : undefined;
        this.sections = [];
        if (obj && obj.sections !== undefined) {
            obj.sections.forEach((section: IConfigurationSection) => {
                this.sections.push(new ConfigurationSection(section));
            });
        }
    }
}
